export const selectNotifications = (state) => state.notification.items || [];
